import { Component, ElementRef, HostListener, ModuleWithProviders, NgZone, ViewChild,AfterViewInit } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import swal from "sweetalert2";
import { ApidataService } from '../apidata.service';
import { HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http';
import { Router, NavigationEnd } from '@angular/router';
import { FooterComponent } from '../footer/footer.component';
import { MetaTagService } from '../meta-tag.service';
import { ChangeDetectorRef } from '@angular/core';
import { environment, GINConstants } from '../../environments/environments';
import { FeedbackComponent } from '../feedback/feedback.component';
import { IconsFreeToolsComponent } from '../icons-free-tools/icons-free-tools.component';
import { PremiumComponent } from "../premium/premium.component";
import { PremiumModalStartupComponent } from '../premium-modal/premium-modal.component';
declare var $: any;
declare var Dropbox: any;
declare var gapi: any;
declare var google: any;
declare var FB: any;
declare var window: any;
@Component({
  selector: 'app-summarize',
  standalone: true,
  imports: [HeaderComponent, CommonModule, FormsModule, ReactiveFormsModule, HttpClientModule, FooterComponent, FeedbackComponent,
    IconsFreeToolsComponent, PremiumComponent,
    PremiumModalStartupComponent,
  ],
  providers: [ApidataService],
  templateUrl: './summarize.component.html',
  styleUrl: './summarize.component.css'
})
export class SummarizeComponent {

  public cleartxtbtn: boolean = false;
  assistantVisible: boolean = false;
  isDropdownOpen = false;
  public showfeedbackloader: boolean = false;
  public eFsubIF: boolean = false;
  public gotresponse: boolean = false;
  ifsub: boolean = false;
  public sentence_mode: boolean = false;
  public send25: boolean = false;
  public send50: boolean = true;
  public copiedtext: boolean = false;
  public pickerApiLoaded = false;
  public mode_para: boolean = false;
  public send75: boolean = false;
  public status: boolean = false;
  public showbuttons: boolean = false;
  public Paragraphmode: boolean = true;
  public Sentencesmode: boolean = false;
  public loaderAlert: boolean = false;
  public menuafterresponse: boolean = false;
  showParagraph: boolean = true;
  error: boolean = false;
  success: boolean = false;
  subscribed_user: boolean = false;
  isUserLoggedin: boolean = false;


  activeTab: string = '';
  public esubText: string = '';
  public esubText2: string = '';
  public color: string = 'black';
  editortxt = '';
  percentage = '50';
  modetype = '';
  public copried_txt: string = '';
  selectedTab: string = 'tab1';



  public form_message: any;
  public form_email: any;
  eFsubText2: any;
  public oauthToken?: any;
  recaptcha_message = ""
  got_recpatcha: boolean = false;
  captchaToken: string | null = null;

  selectedValue: number;
  public BRformodel = 0;
  char_count = 0;
  word_count = 0;
  count = 5;


  public editortext;
  dangerAlerts;
  errorAlerts;
  successAlert;




  public clientId = "859452103362-3aroha97qk7nt8ps6ocl70k10pj7uuvt.apps.googleusercontent.com";
  public spanwords = [];
  public scope = [
    "profile",
    "email",
    "https://www.googleapis.com/auth/drive.file", 
  ].join(" ");

  stars: number[] = [1, 2, 3, 4, 5];

  @ViewChild("text") text: ElementRef;
  @ViewChild("fileInput") fileInput;
  @ViewChild('editor') editor!: ElementRef<HTMLDivElement>;


  constructor(private cdr: ChangeDetectorRef, private httpClient: ApidataService, private router: Router, private https: HttpClient, private metaService: MetaTagService, private cd: ChangeDetectorRef) { }



  ngOnInit(): void {
    //  const isMobile = window.innerWidth <= 600;

    // if (isMobile) {
    //   this.router.navigate(['/app-summarize']);
    // } else {
    //   this.router.navigate(['/text-summarizer']);
    // }
    if (this.captchaVisible) {
      this.loadAndRenderTurnstile();
    }


    this.metaService.updateTags("Text Summarizer | A.I Based Text Summarizing Tool", "Use our text summarizer which is AI based Summarizing tool to generates summary to summarize long text. Extract the key points with summary generator tool.", "https://www.grammarin.com/text-summarizer", "https://www.grammarin.com/assets/images/OG-Images/Text Summarizer.png", 'Text Summarizer');

    this.textfromAI();
 
    $(".tab_content").hide();
    $(".tab_content:first").show();

 
    $("ul.tabs li").click(function () {

      $(".tab_content").hide();
      var activeTab = $(this).attr("rel");
      $("#" + activeTab).fadeIn();

      $("ul.tabs li").removeClass("active");
      $(this).addClass("active");

      $(".tab_drawer_heading").removeClass("d_active");
      $(".tab_drawer_heading[rel^='" + activeTab + "']").addClass("d_active");

 
    });
    $(".tab_container").css("min-height", function () {
      return $(".tabs").outerHeight() + 50;
    });
   
    $(".tab_drawer_heading").click(function () {

      $(".tab_content").hide();
      var d_activeTab = $(this).attr("rel");
      $("#" + d_activeTab).fadeIn();

      $(".tab_drawer_heading").removeClass("d_active");
      $(this).addClass("d_active");

      $("ul.tabs li").removeClass("active");
      $("ul.tabs li[rel^='" + d_activeTab + "']").addClass("active");
    });

    this.activeTab = 'q5';
  }
  recaptchaWidgetId: number | undefined;




  captchaVisible: boolean = false;  
  isCaptchaVerified: boolean = false; 
  recaptchaMessage: string = '';  


  handleButtonClick(): void {
    if (this.loaderAlert) {
      return;
    }
    $("#editor").find("span").contents().unwrap();
    this.char_count = $("#editor").text().length;
    this.word_count = $("#editor").text().trim().split(/\s+/).length;

  
    // if (this.word_count >= 10 && this.word_count <= 300) {
    //   this.showCaptchaModal();  
    // } else {
    //   this.showAlert("Enter 10 to 300 words to check the text Summarize.", "");
    // }
    if(!this.subscribed_user)
      if (this.word_count >= 15 && this.word_count <= 1000 ) {
        this.showCaptchaModal(); 
    } else {
      this.showAlert("Enter 15 to 1000  words to check the text Summarize.", "");
    }
    else if(this.subscribed_user )
      if (this.word_count >= 15 && this.word_count <= 10000    ) {
        this.showCaptchaModal(); 
    } else {
      this.showAlert("Enter 15 to 10,000  words to check the text Summarize.", "");
    }
  }

 
  showCaptchaModal(): void {
    if (!this.captchaVisible) {
      this.captchaVisible = true;  
      this.cdr.detectChanges();   
      this.loadAndRenderTurnstile();  
    } else {
      this.recaptchaMessage = 'Please complete the CAPTCHA.';  
      this.color = '#721c24';  
    }
  }

  loadAndRenderTurnstile(): void {
    if (typeof window['turnstile'] === 'undefined') {
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
      script.async = true;
      script.defer = true;
      script.onload = () => this.renderTurnstile();
      script.onerror = () =>
        //  console.error('Failed to load Turnstile script.');
      document.body.appendChild(script);
    } else {
      this.renderTurnstile();
    }
  }


  renderTurnstile(): void {
    const containerElement = document.getElementById('recaptcha-container');
    if (!containerElement) {
    
      return;
    }

    window['turnstile'].render(containerElement, {
      sitekey: environment.CaptchaKey,  
      size: 'normal',
      callback: (token: string) => this.onTurnstileSuccess(token),
      'error-callback': () => this.onTurnstileError(),
    });

  }


  onTurnstileSuccess(token: string): void {
    // console.log('Turnstile token received:', token);
    this.captchaToken = token;
    this.isCaptchaVerified = true;  
    this.captchaVisible = false;   
    this.recaptchaMessage = '';    
    this.textsummerapi();  
  }


  onTurnstileError(): void {
    // console.error('Turnstile error occurred.');
    this.captchaToken = null;
    this.recaptchaMessage = 'CAPTCHA verification failed. Please try again.';
    this.color = '#721c24';  
  }


  resetTurnstile(): void {
    const containerElement = document.getElementById('recaptcha-container');
    if (typeof window['turnstile'] !== 'undefined') {
      window['turnstile'].reset(containerElement);
      // console.log('Turnstile CAPTCHA reset.');
    } else {
      // console.error('Turnstile library not loaded.');
    }
  }




  ///// recaptcha end


  toggleTab(tabId: string): void {
    if (this.activeTab === tabId) {
      this.activeTab = '';
    } else {
      this.activeTab = tabId;
    }
  }

  selectTab(tab: string): void {
 
    this.selectedTab = tab;
  }
  editorTxtAI: string;

  textfromAI() {
    if (localStorage.getItem('editorValueAI')) {
      this.showParagraph = false;
    }
    setTimeout(() => {
      if (localStorage.getItem('editorValueAI')) {
        this.editorTxtAI = localStorage.getItem('editorValueAI');
        this.showParagraph = false;
        this.char_count = this.editorTxtAI.length;
        this.word_count = this.editorTxtAI.trim().split(/\s+/).length;
        localStorage.removeItem('editorValueAI');

        if (this.editorTxtAI != null && this.editorTxtAI.length !== 0) {
          this.textDivRef.nativeElement.innerHTML = this.editorTxtAI;
        }
      }
    }, 1000);
  }
  pcroute() {

    var editortxt = '';
    editortxt = $("#summrizesection").text();
  
    localStorage.setItem('editorValueAI', editortxt);
    const url = this.router.serializeUrl(this.router.createUrlTree(['/plagiarism-checker']));
    window.open(url, '_blank');
  }
  gcroute() {
 
    var editortxt = '';
    editortxt = $("#summrizesection").text();
    localStorage.setItem('editorValueAI', editortxt);
    const url = this.router.serializeUrl(this.router.createUrlTree(['']));
    window.open(url, '_blank');
  }
  // SCROL
  shouldShowButton: boolean = false;
  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (window.pageYOffset > 200) {
      this.shouldShowButton = true;
    } else {
      this.shouldShowButton = false;
    }
  }
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  // feedback

  countStar(star) {
    this.selectedValue = star;

  }
  public ngAfterViewInit(): void {

    this.getBrowserWidth()

    const storedStatus = JSON.parse(localStorage.getItem('premium_user_done') || 'false');
    this.subscribed_user = storedStatus;
    this.profile_id = localStorage.getItem("profile_id");
    if (!this.profile_id) {
      this.profile_id = '1';
      this.isUserLoggedin = false;
    }
    else {
      this.isUserLoggedin = true;
    }

    if (this.profile_id && this.profile_id != 1) {
      this.httpClient
        .getUserProfileContents(this.profile_id)
        .subscribe((data) => {
         this.LoadProfileData(data)
          
        });

    
    } 

  }
 
  public LoadProfileData(data: Response) {
    let receivedData = data;
    this.subscribed_user= receivedData['contents'][0][5];
  }
  public mobilescreen: boolean = false;
  public responseformodbile: boolean = false;
  public getBrowserWidth = function () {
 
    if (window.innerWidth <= 430) {
      this.mobilescreen = true;
      this.responseformodbile = false;
      return "xs";
    } else if (window.innerWidth < 991) {
      this.mobilescreen = true;
      this.responseformodbile = false;
      return "sm"
    } else if (window.innerWidth < 1199) {
      this.mobilescreen = true;
      this.responseformodbile = false;
      return "md"
    } else {
      this.mobilescreen = false;
      this.responseformodbile = false;
      return "lg"
    }
  };

  checkMail() {
    var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    this.form_email = $('#form_email').val();
    if (
      reg.test(this.form_email) === false
    ) {
      this.color = '#721c24';
      this.dangerAlerts = 'Please provide correct Email';
      $('#form_email').val('').css("border-color", "red");
      this.ifsub = true
      $("#dangerAlerts").show();
      setTimeout(function () {
        $("#dangerAlerts").hide();
        $('#form_email').css("border-color", "#08ba9c");
        this.ifsub = false
      }, 3000);
    }
  }
  clearfeedbackform() {
    this.selectedValue = 0;
    $('#form_email').val('').css("border-color", "#e7e7ec");
    $('#form_message').val('').css("border-color", "#e7e7ec");
  }
  public eFormSubmission(event: any) {
    event.preventDefault();
    this.eFsubIF = false
    $("#eFsubText2").hide();
    this.form_email = $('#form_email').val();
    this.form_message = $('#form_message').val();
    var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (this.form_message.length === 0) {
      this.color = '#721c24';
      this.eFsubText2 = 'Please provide the required fields';
      $('#form_message').val('').css("border-color", "red");
      this.eFsubIF = true
      $("#eFsubText2").show();
      setTimeout(function () {
        $("#eFsubText2").hide();
        $('#form_message').css("border-color", "#08ba9c");
        this.eFsubIF = false
      }, 3000);
    }
    else {
      this.showfeedbackloader = true;
      const headers = new HttpHeaders({
        'Authorization': environment.AuthorizationGIN,
      });
      this.https.post(environment.API_URL + '/api/feedbackForm', { 'email': this.form_email, 'comment': this.form_message, 'page_name': "home", 'emotion': this.selectedValue }, { headers }).subscribe(
        (response) => {
          this.showfeedbackloader = false
          this.color = 'green';
          this.eFsubText2 = 'Form Submitted Successfully!';
          this.eFsubIF = true
          $("#eFsubText2").show();
          setTimeout(function () {
            $("#eFsubText2").hide();
            this.eFsubIF = false
          }, 3000);
          $('#form_email').val('').css("border-color", "#08ba9c");
          $('#form_message').val('').css("border-color", "#08ba9c");
        },
        (error) => {
          // console.error(error);
        }
      );

    }
  }
  onclickeditor(event: MouseEvent) {
    event.stopPropagation(); 

    if (this.char_count === 0 && !this.showParagraph) {
      this.word_count = 0
      this.char_count = 0
    }
    this.showParagraph = false; 

  }
  public getContent(event, text) {
    var ctrlDown = false,
      ctrlKey = 17,
      cmdKey = 91,
      vKey = 86,
      cKey = 67;
    this.editortext = text;
    if (ctrlDown && event.keyCode == vKey) {
      this.showParagraph = false;
   
    }
   
    this.char_count = $("#editor").text().length;
    this.word_count = $("#editor").text().split(/\s+/).length;
  
  }
  paramode() {
    this.Paragraphmode = true;
    this.mode_para = true;
    this.sentence_mode = false;
    this.Sentencesmode = false;
  }
  sentence_modetype() {
    this.Paragraphmode = false;
    this.sentence_mode = true;
    this.mode_para = false;
    this.Sentencesmode = true;
  }
  got25percentage() {
    this.send25 = true;
    this.send50 = false;
    this.send75 = false;
  }
  got50percentage() {
    this.send50 = true;
    this.send25 = false;
    this.send75 = false;
  }
  got75percentage() {
    this.send50 = false;
    this.send25 = false;
    this.send75 = true;
  }
  textsummerapi() {
  
    this.editortxt = $("#editor").text();
 
    this.menuafterresponse = false;
    this.showbuttons = false;
 
    const editorContent = $('#editor').text().trim();

    const isPlaceholder =
      editorContent === "Upload Your Content" ||
      editorContent === "Type or Paste AI Text here";
    if (!this.isCaptchaVerified) {

      return; 
    }

    if (isPlaceholder || editorContent === "") {
      this.showAlert(" Enter 10 to 300 words to check the text Summarize.", "");
      return;
    }

    if (this.mode_para) {
      this.modetype = 'paragraph';
    }
    if (this.sentence_mode) {
      this.modetype = 'key_sentences';
    }
    else {
      this.modetype = 'paragraph';
    }

    if (this.send25) {
      this.percentage = '25';

    } else if (this.send50) {
      this.percentage = '50';

    } else if (this.send75) {
      this.percentage = '75';

    } else {
      this.percentage = '50';
   
    }

    if (this.word_count >= 15 ) {
      this.loaderAlert = true;
      this.cleartxtbtn = true;
      this.char_count = $("#editor").text().length;
      this.word_count = $("#editor").text().split(/\s+/).length;

      if (window.innerWidth > 868){
        let data2 = JSON.stringify({
          homeText: editorContent,
          profile_id: this.profile_id || '1',
        });
  
        let url = environment.API_URL + '/api/getNewDocIDForGuestByContents';
  
        this.httpClient.postResources(data2, url).subscribe((data) => {
          let receivedData = data;
  
          localStorage.setItem('editorValueAI', editorContent);
          this.doc_id = receivedData['new_doc_id'];
  
          this.router.navigate(['/textsummarizer'], {
            queryParams: { doc: this.doc_id },
          });
  
          const url = this.router.serializeUrl(this.router.createUrlTree(['']));
     
        });
        return;
      }
      if (this.modetype === 'paragraph') {
        this.gotresponse = true;


        this.httpClient.textsummarizerapi(this.editortxt, this.percentage, this.modetype).subscribe(data => {
          $('#editor').html(this.editortxt);
          $('#summrizesection').html('');
          var check = $('#editor').html(this.editortxt);
     
          this.menuafterresponse = true;
          this.showbuttons = true;
          var content = data["summarized_content"];
          this.loaderAlert = false;
          $('#summrizesection').html(content);
          document.getElementById('summrizesection').setAttribute('contenteditable', 'false');
          this.cleartxtbtn = false;
  
        });
      }
      else {
        this.gotresponse = true;
        this.httpClient.textsummarizerapi(this.editortxt, this.percentage, this.modetype).subscribe(data => {
          this.showbuttons = true;
          this.menuafterresponse = true;

          $('#editor').html(this.editortxt);
          var content = data["summarized_content"];
          $('#summrizesection').html('');
          var pushloopcontent = [];
        

          for (let i = 0; i < content.length; i++) {
            var loopcontent = content[i];
            pushloopcontent.push(loopcontent);
           
            if (!document.getElementById('contentList')) {
              const ul = document.createElement('ul');
              ul.id = 'contentList';
              document.getElementById('summrizesection').appendChild(ul);
            }

      
            const li = document.createElement('li');
            li.textContent = loopcontent;
            document.getElementById('contentList').appendChild(li);

        
            document.getElementById('summrizesection').setAttribute('contenteditable', 'false');
          }
          this.loaderAlert = false;
          this.cleartxtbtn = false;
        });
      }

    }
    else {
   
      if( !this.subscribed_user)
        {
          this.showAlert("Enter 15 to 1000  words to check the text Summarize.", "");
        }
        else if( this.subscribed_user ){
          this.showAlert("Enter 15 to 10,000  words to check the text Summarize.", "");
        }
      // this.showAlert(" Enter 10 to 300 words to check the text Summarize.", "");
    }
  }

  profile_id;
  public doc_id = '';

  // textsummerapi() {
  
  //   this.editortxt = $("#editor").text();
 
  //   this.menuafterresponse = false;
  //   this.showbuttons = false;
 
  //   const editorContent = $('#editor').text().trim();

  //   const isPlaceholder =
  //     editorContent === "Upload Your Content" ||
  //     editorContent === "Type or Paste AI Text here";
  //   if (!this.isCaptchaVerified) {

  //     return; 
  //   }

  //   if (isPlaceholder || editorContent === "") {
  //     this.showAlert(" Enter 10 to 300 words to check the text Summarize.", "");
  //     return;
  //   }

  //   if (this.mode_para) {
  //     this.modetype = 'paragraph';
  //   }
  //   if (this.sentence_mode) {
  //     this.modetype = 'key_sentences';
  //   }
  //   else {
  //     this.modetype = 'paragraph';
  //   }

  //   if (this.send25) {
  //     this.percentage = '25';

  //   } else if (this.send50) {
  //     this.percentage = '50';

  //   } else if (this.send75) {
  //     this.percentage = '75';

  //   } else {
  //     this.percentage = '50';
   
  //   }

  //   if (this.word_count >= 10 && this.word_count <= 300) {
  //     this.loaderAlert = true;
  //     this.cleartxtbtn = true;
  //     this.char_count = $("#editor").text().length;
  //     this.word_count = $("#editor").text().split(/\s+/).length;
  //     this.loaderAlert = true;
  //     let data2 = JSON.stringify({
  //       homeText: editorContent,
  //       profile_id: this.profile_id || '1',
  //     });

  //     let url = environment.API_URL + '/api/getNewDocIDForGuestByContents';

  //     this.httpClient.postResources(data2, url).subscribe((data) => {
  //       let receivedData = data;

  //       localStorage.setItem('editorValueAI', editorContent);
  //       this.doc_id = receivedData['new_doc_id'];

  //       this.router.navigate(['/textsummarizer'], {
  //         queryParams: { doc: this.doc_id },
  //       });

  //       const url = this.router.serializeUrl(this.router.createUrlTree(['']));
   
  //     });

  //   }
  //   else {
   
  //     this.showAlert(" Enter 10 to 300 words to check the text Summarize.", "");
  //   }
  // }


  showAlert(message, selector) {


    this.errorAlerts = message;
    $(selector).css('border-color', 'red');
    this.error = true;
    $('#errorAlerts').show();
    setTimeout(() => {
      $('#errorAlerts').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.error = false;
    }, 4000);

  }

  showSuccess(message, selector) {
    this.successAlert = message;
    this.success = true;
    $('#successAlert').show();
    setTimeout(() => {
      $('#successAlert').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.success = false;
    }, 4000);
  }

  closeErrorDiv() {
    this.error = false; 
  }

  ////////////// Upload file function from browser //////////
  public uploadFileSaveRedirect(event): void {
    $("#UpFileModal").modal({ backdrop: "static", keyboard: false });


    const files: FileList = this.fileInput.nativeElement.files;

    var filetype = "pdf";
    // this.loaderAlert = true;
    if (files[0].size > 5243000) {
   
      this.showAlert("File should be less than 5 MB", "");
    }
    else {
      let input = event.target;
     
      this.menuafterresponse = false;
      this.showbuttons = false;
      this.gotresponse = false;
      this.loaderAlert = true;
      this.showParagraph = true;
      this.word_count = 0;
      this.char_count = 0;
      this.showParagraph = false;
      var testingnew = document.getElementById("editor");
      if (testingnew.textContent != '') {
        testingnew.textContent = ''
      }
      this.httpClient.uploadfilefrombrowser(files).subscribe(
        (data => {
          this.loaderAlert = false;
         

          let receivedData = data;
          $("#editor").html(receivedData['RetCnt']);
          this.editortxt = receivedData['RetCnt']
          this.getContent('', receivedData['RetCnt'])

          this.fileInput.nativeElement.value = '';
          // }
        }
        ),
        (error) => {
          this.loaderAlert = false;
     
          this.showAlert("Unable to proceed with a password protected file", "");
        }
      )
    }
  }
  /////////// dropbox functionn////////
  openDropboxChooser(): void {
    const options = {
      success: (files: any) => {
        let fileType = this.getFileType(files[0].name);

        if (fileType === 'docx' || fileType === 'pdf' || fileType === 'txt') {
          this.uploadFileToServer(files[0].link, fileType);
        } else {
          // console.error('Unsupported file type');
        }
      },
      cancel: () => { },
      linkType: 'direct',
      multiselect: false,
      extensions: ['.docx', '.pdf', '.txt'],
      sizeLimit: 1024 * 1024 * 5
    };
    Dropbox.choose(options);
  }

  getFileType(fileName: string): string {
    const fileExtension = fileName.split('.').pop();
    return fileExtension ? fileExtension.toLowerCase() : '';
  }

  uploadFileToServer(fileLink: string, fileType: string): void {
  
    this.showParagraph = false;
    this.loaderAlert = true;
    this.httpClient.dropboxfile(fileType, fileLink).subscribe(data => {

      let receivedData = data;
      $("#editor").html(receivedData['RetCnt']);
      this.getContent('', receivedData['RetCnt'])
      this.loaderAlert = false;
    })
  }
  ///////////////// google drive api///////////
 
  ///////// copy and download

  copyText() {
    const editorElement = document.getElementById("summrizesection");
    if (editorElement) {

      const range = document.createRange();
      range.selectNode(editorElement);
      window.getSelection()?.removeAllRanges();
      window.getSelection()?.addRange(range);

      try {
        document.execCommand('copy');

        this.copiedtext = true;
        this.copried_txt = 'copied';
        $("#copytextId").hide();
        $("#copried_txt").show();
        setTimeout(function () {
          $("#copried_txt").hide(); $("#copytextId").show();
          this.copiedtext = false;
        }, 2000);
      } catch (err) {
        this.copiedtext = false;
      }
      window.getSelection()?.removeAllRanges();
    }
  }
  downloadText() {
    const editorElement = this.editor.nativeElement;
    if (editorElement) {
      const textContent = editorElement.innerText;

  
      const blob = new Blob([textContent], { type: 'text/plain' });

   
      const a = document.createElement('a');
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = 'Text Summarizer-Report.txt';

 
      document.body.appendChild(a);
      a.click();


      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }
  }
  ///////// sample text
  sampletext() {
    $("#editor").html("We all are aware of the fact that plagiarism can destroy our careers and websites' credibility. Suppose you have detected that some proportion of your text is plagiarized. In that case, you can opt to use the best article rewriter to make your plagiarized sentences and display their plagiarism-free version in a matter of seconds. It means that it's not only wasted an hour or more trying to rewrite plagiarism from the text yourself and then putting to some responsibility for both of these demanding jobs and providing you 100% unique content in the blink of an eye. There is plagiarism, but only some platforms will provide you with the quality Grammarin offers. This article is jam-packed with top-notch features to facilitate you in the best way possible. You can enjoy the following features.")
    this.char_count = $("#editor").text().length;
    this.word_count = $("#editor").text().trim().split(" ").length;
    this.showParagraph = false;
  }
  pasteText(): void {
    navigator.clipboard.readText().then(pastedText => {
      document.execCommand('insertText', false, pastedText);
  
      $("#editor").html(pastedText);
      this.char_count = $("#editor").text().length;
      this.word_count = $("#editor").text().trim().split(" ").length;
      this.showParagraph = false;
    }).catch(err => {
      // console.error('Failed to read clipboard contents: ', err);
    });
  }

  @HostListener('document:click', ['$event.target'])
  onClickOutside(targetElement: HTMLElement) {
    if (!this.editor) {
      // console.error('Editor element is not defined');
      return;
    }

    const clickedElementId = targetElement.id;
    

    const excludedButtonIds = ['checkgrammar-btn-para', 'downloadfile', 'copy-btn', 'retry-btn', 'footerlinksforroute'];
    const editorContent = this.editor.nativeElement.innerText.trim();

    if (editorContent !== '') {
      return; 
    }

    if (excludedButtonIds.includes(clickedElementId)) {
      return; 
    }

    if (!this.editor.nativeElement.contains(targetElement)) {
   
      if (!this.word_count || !this.char_count) {
        this.showParagraph = true;
      } else {
        this.showParagraph = false;
      }

      this.word_count = 0;
      this.char_count = 0;

      const editorText = this.editor.nativeElement.innerText.trim();
      this.word_count = editorText.split(/\s+/).filter(word => word.length > 0).length;
      this.char_count = editorText.length;
    }
  }
  /////////// on paste
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault(); 
    const clipboardData = event.clipboardData;  
    const targetElement = event.target as HTMLElement;
   
    if ((targetElement.id === 'editor' || targetElement.closest('#editor')) && clipboardData && clipboardData.getData) {
      const pastedContent = clipboardData.getData('text/plain');
    
      const selection = window.getSelection();
      if (selection && selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);

        if (!range.collapsed) {
        
          range.deleteContents();
          range.insertNode(document.createTextNode(pastedContent));
        } else {
     
          range.insertNode(document.createTextNode(pastedContent));
        }
    
        const newRange = document.createRange();
        newRange.selectNodeContents(range.endContainer);
        newRange.collapse(false);
  
        selection.removeAllRanges();
        selection.addRange(newRange);
      }


      this.showParagraph = false;

      this.char_count = $("#editor").text().length;
      this.word_count = $("#editor").text().trim().split(/\s+/).length;
    
    }
  }


  /// dropbox  gDriveUpload functionn////////
  public gDriveUpload() {
    gapi.load("auth", { callback: this.onAuthApiLoad.bind(this) });
    gapi.load("picker", { callback: this.onPickerApiLoad.bind(this) });
    const simulatedEvent = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
    });

    this.onclickeditor(simulatedEvent);

    setTimeout(() => {
      const editorElement = $("#editor").get(0);
      if (editorElement) {
        const event = new KeyboardEvent('keydown', {
          key: '.',
          code: 'Period',
          keyCode: 190, // KeyCode for '.'
          bubbles: true
        });

        editorElement.dispatchEvent(event);
      }
    }, 1000);
  }

  public onAuthApiLoad() {
    gapi.auth.authorize(
      {
        client_id: this.clientId,
        scope: this.scope,
        immediate: false,
      },
      this.handleAuthResult
    );
  }

  public onPickerApiLoad() {
    this.pickerApiLoaded = true;
  }
  isExport: boolean = false;
  public handleAuthResult(authResult) {
    $("#UpFileModal").modal("hide");
    let src;

    if (authResult && !authResult.error) {
      if (authResult.access_token) {
        let view = new google.picker.View(google.picker.ViewId.DOCS);
   
        view.setMimeTypes(
          "application/pdf,application/txt,text/plain,application/vnd.oasis.opendocument.text,application/vnd.google-apps.document,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        );

        let pickerBuilder = new google.picker.PickerBuilder();
        let picker = pickerBuilder
          .enableFeature(google.picker.Feature.MINE_ONLY)
          .setOAuthToken(authResult.access_token)
          .addView(view)
          .addView(new google.picker.DocsUploadView())
          .setCallback(function (e) {
            if (e.action == google.picker.Action.PICKED) {
              var fileId = e.docs[0].id;
              var file = e.docs[0].url;
              var files = e.docs[0];
              if (files.sizeBytes > 5243000) {
                this.lodershow = false;
             
                swal({
                  background: "#FFFFFF",
                  title: "Error",
                  html: `
                  <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
                    background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
                    <div class="text-center" style="margin-top: 9%;">
                      <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
                      <div style="width: 323px; height: 64px; margin-left: 77px;">
                        <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                          File should be less than 5 MB
                        </p>
                      </div>
                      <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                        border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                        class="mt-4 butn-alert">Ok</button>
                    </div>
                  </div>
                `,
                  showConfirmButton: false,
                  width: "323px",
                  timer: 4000
                });

          
                setTimeout(() => {
                  const okButton = document.getElementById('swal-ok-button');
                  if (okButton) {
                    okButton.addEventListener('click', () => {
                      swal.close(); 
                    });
                  }
                }, 0);
              }
              else {
                if (e.docs[0].name.split(".")[1] === "pdf") {

             
                  let filelink2 = file + fileId;
                  let linksvalue =
                    "https://drive.google.com/u/0/uc?id=" +
                    fileId +
                    "&export=download";
                  if (localStorage.getItem("profile_id")) {
                    var profile_id = localStorage.getItem("profile_id");
                  } else {
                    var profile_id = "1";
                  }
                  $.ajax({
                    url: environment.API_URL + "/api/downloadFromDrive",
                    type: "post",
                
                    dataType: "json",
                    data: {
                      profile_id: profile_id,
                      hash: authResult.access_token,
                      file_path: fileId,
                      file_type: "pdf",
                      create_chunks: 'false',
                    },
                    beforeSend: function (xhr) {
                      xhr.setRequestHeader(
                        "Authorization",
                        +localStorage.getItem("token")
                      );
                    },

                    success: function (return_data) {
           
                      $("#editor").html(return_data.RetCnt);

                      const Characters = $("#editor").text().length;
                      const words = $("#editor").text().trim().split(/\s+/).filter(word => word.length > 0).length;

                   
                      let data2 = JSON.stringify({
                        homeText: return_data.RetCnt,
                        profile_id: profile_id
                      });
                      const simulatedEvent = new MouseEvent('click', {
                        bubbles: true,
                        cancelable: true,
                      });
             
                      this.onclickeditor(simulatedEvent);

                      setTimeout(() => {
                        const editorElement = $("#editor").get(0);
                        if (editorElement) {
                          const event = new KeyboardEvent('keydown', {
                            key: '.',
                            code: 'Period',
                            keyCode: 190, // KeyCode for '.'
                            bubbles: true
                          });

                          editorElement.dispatchEvent(event);
                        }
                      }, 1000);

                  

                    },
                    error: function (data) {
                  
                      swal({
                        background: "#FFFFFF",
                        title: "Error",
                        html: `
      <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
        background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
        <div class="text-center" style="margin-top: 9%;">
          <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
          <div style="    width: 369px; height: 64px; margin-left: 39px;">
            <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
              This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
            </p>
          </div>
          <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
            border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
            class="mt-5 butn-alert">Ok</button>
        </div>
      </div>
    `,
                        showConfirmButton: false,
                        width: "323px",
                        timer: 4000
                      });


                      setTimeout(() => {
                        const okButton = document.getElementById('swal-ok-button');
                        if (okButton) {
                          okButton.addEventListener('click', () => {
                            swal.close(); 
                          });
                        }
                      }, 0);

                    }
                  });
                } else if (e.docs[0].name.split(".")[1] === "txt") {
            
                  let filelink2 = file + fileId;
                  let linksvalue =
                    "https://drive.google.com/u/0/uc?id=" +
                    fileId +
                    "&export=download";

                  if (localStorage.getItem("profile_id")) {
                    var profile_id = localStorage.getItem("profile_id");
                  } else {
                    var profile_id = "1";
                  }
                  $.ajax({
                    url: environment.API_URL + "/api/downloadFromDrive",
                    type: "post",
                  
                    dataType: "json",
                    data: {
                      profile_id: profile_id,
                      hash: authResult.access_token,
                      file_path: fileId,
                      file_type: "txt",
                      create_chunks: 'false',
                    },
                    beforeSend: function (xhr) {
                      xhr.setRequestHeader(
                        "Authorization",
                        +localStorage.getItem("token")
                      );
                    },

                    success: function (return_data) {
                      $("#editor").html(return_data.RetCnt);
                      this.hideothers = true;

                      const Characters = $("#editor").text().length;
                      const words = $("#editor").text().trim().split(/\s+/).filter(word => word.length > 0).length;

                      let data2 = JSON.stringify({
                        homeText: return_data.RetCnt,
                        profile_id: profile_id
                      });
                      const simulatedEvent = new MouseEvent('click', {
                        bubbles: true,
                        cancelable: true,
                      });
     
                      this.onclickeditor(simulatedEvent);

                      setTimeout(() => {
                        const editorElement = $("#editor").get(0);
                        if (editorElement) {
                          const event = new KeyboardEvent('keydown', {
                            key: '.',
                            code: 'Period',
                            keyCode: 190, 
                            bubbles: true
                          });

                          editorElement.dispatchEvent(event);
                        }
                      }, 1000);
                  

                    },
                    error: function (data) {
                   
                      swal({
                        background: "#FFFFFF",
                        title: "Error",
                        html: `
                      <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
                        background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
                        <div class="text-center" style="margin-top: 9%;">
                          <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
                          <div style="    width: 369px; height: 64px; margin-left: 39px;">
                            <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                              This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
                            </p>
                          </div>
                          <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                            border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                            class="mt-5 butn-alert">Ok</button>
                        </div>
                      </div>
                    `,
                        showConfirmButton: false,
                        width: "323px",
                        timer: 4000
                      });


     
                      setTimeout(() => {
                        const okButton = document.getElementById('swal-ok-button');
                        if (okButton) {
                          okButton.addEventListener('click', () => {
                            swal.close(); 
                          });
                        }
                      }, 0);

                    }
                  });
                } else if (e.docs[0].name) {
         
                  let filelink2 = file + fileId;
                  let linksvalue =
                    "https://docs.google.com/feeds/download/documents/export/Export?id=" +
                    fileId +
                    "&exportFormat=docx";
                  if (localStorage.getItem("profile_id")) {
                    var profile_id = localStorage.getItem("profile_id");
                  } else {
                    var profile_id = "1";
                  }
                  $.ajax({
                    url: environment.API_URL + "/api/downloadFromDrive",
                    type: "post",
                  
                    dataType: "json",
                    data: {
                      profile_id: profile_id,
                      hash: authResult.access_token,
                      file_path: fileId,
                      file_type: "docx",
                      create_chunks: 'false',
                    },
                    beforeSend: function (xhr) {
                      xhr.setRequestHeader(
                        "Authorization",
                        +localStorage.getItem("token")
                      );
                    },

                    success: function (return_data) {
                      $("#editor").html(return_data.RetCnt);

                      const Characters = $("#editor").text().length;
                      const words = $("#editor").text().trim().split(/\s+/).filter(word => word.length > 0).length;

                   
                      let data2 = JSON.stringify({
                        homeText: return_data.RetCnt,
                        profile_id: profile_id
                      });
                      const simulatedEvent = new MouseEvent('click', {
                        bubbles: true,
                        cancelable: true,
                      });
              
                      this.onclickeditor(simulatedEvent);

                      setTimeout(() => {
                        const editorElement = $("#editor").get(0);
                        if (editorElement) {
                          const event = new KeyboardEvent('keydown', {
                            key: '.',
                            code: 'Period',
                            keyCode: 190, // KeyCode for '.'
                            bubbles: true
                          });

                          editorElement.dispatchEvent(event);
                        }
                      }, 1000);

                    

                    },
                    error: function (data) {
                  
                      swal({
                        background: "#FFFFFF",
                        title: "Error",
                        html: `
                      <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
                        background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
                        <div class="text-center" style="margin-top: 9%;">
                          <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
                          <div style="    width: 369px; height: 64px; margin-left: 39px;">
                            <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                              This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
                            </p>
                          </div>
                          <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                            border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                            class="mt-5 butn-alert">Ok</button>
                        </div>
                      </div>
                    `,
                        showConfirmButton: false,
                        width: "323px",
                        timer: 4000
                      });


            
                      setTimeout(() => {
                        const okButton = document.getElementById('swal-ok-button');
                        if (okButton) {
                          okButton.addEventListener('click', () => {
                            swal.close(); 
                          });
                        }
                      }, 0);

                    }
                  });
                }
              }
            }
          })
          .build();
        picker.setVisible(true);
      }
    }
    const simulatedEvent = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
    });

    this.onclickeditor(simulatedEvent);

    setTimeout(() => {
      const editorElement = $("#editor").get(0);
      if (editorElement) {
        const event = new KeyboardEvent('keydown', {
          key: '.',
          code: 'Period',
          keyCode: 190, 
          bubbles: true
        });

        editorElement.dispatchEvent(event);
      }
    }, 1000);
  }




  updateSliderStyle(event: any) {
    const slider = event.target;
    const min = +slider.min;
    const max = +slider.max;
    const value = +slider.value;


    const percentage = ((value - min) / (max - min)) * 100;


    let color1 = '#00B693';
    let color2 = '#00B693';
    let color3 = '#00B693';
    let color4 = '#00B693';


    let gradient = '';

    if (percentage <= 25) {
      gradient = `linear-gradient(to right, ${color1} ${percentage}%, #DEE2E6 ${percentage}%)`;
    } else if (percentage <= 50) {
      gradient = `linear-gradient(to right, ${color1} 25%, ${color2} ${percentage}%, #DEE2E6 ${percentage}%)`;
    } else if (percentage <= 75) {
      gradient = `linear-gradient(to right, ${color1} 25%, ${color2} 50%, ${color3} ${percentage}%, #DEE2E6 ${percentage}%)`;
    } else {
      gradient = `linear-gradient(to right, ${color1} 25%, ${color2} 50%, ${color3} 75%, ${color4} ${percentage}%, #DEE2E6 ${percentage}%)`;
    }


    slider.style.background = gradient;
  }

  updatePercentage() {

    const percentageNumber = +this.percentage;

    if (percentageNumber <= 33) {
      this.send25 = true;
      this.send50 = false;
      this.send75 = false;
    } else if (percentageNumber > 33 && percentageNumber <= 66) {
      this.send25 = false;
      this.send50 = true;
      this.send75 = false;
    } else {
      this.send25 = false;
      this.send50 = false;
      this.send75 = true;
    }
  }
  @ViewChild('editor') textDivRef!: ElementRef;
  deleteText() {
    this.loaderAlert = true;
    if (this.textDivRef) {
      this.textDivRef.nativeElement.innerHTML = '';
    }
    this.word_count = 0;
    this.char_count = 0;
    this.loaderAlert = false;
    this.showParagraph = true;

    const result = document.getElementById('summrizesection');
    if (this.gotresponse) {
      this.gotresponse = false;
      result.innerHTML = "";
      const imgElement = document.createElement("img");
      imgElement.src = "../../assets/images/summrizer/summrizer/response.svg";
      imgElement.className = "result-section-img";
      imgElement.style.position = "relative";
      imgElement.style.top = "40%";
      imgElement.style.left = "49%";
      imgElement.style.textAlign = "center";
      imgElement.style.transform = "translate(-50%, -50%)";
      imgElement.style.display = "block";

      result.appendChild(imgElement);
    }

    this.menuafterresponse = false;
  }
  //  objects objects objects

  executeAction(action: string) {
    if (this[action] && typeof this[action] === 'function') {
      this[action]();
    } else {
      // console.error(`Action "${action}" is not a valid method.`);
    }
  }

  contentArray = [
    {
      showParagraph: true,
      header: 'Upload Your Content',
      paragraph: 'Type or Paste AI Text here',
      buttons: [
        {
          text: 'Sample Text',
          icon: 'copyIcon',
          action: 'sampletext'
        },
        {
          text: 'Paste Text',
          icon: 'copyIcon',
          action: 'pasteText'
        }

      ]
    }
  ];
}
